var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDocumentdashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#1f1f1f;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "abb_dashboard_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Box"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 32,
    height: 32
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Final_icons_-_Common",
    "data-name": "Final icons - Common"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M2,5V26a1,1,0,0,0,1,1H29a1,1,0,0,0,1-1V5Zm2,7H17V24H4ZM28,24H19V12h9Zm0-14H4V7H28Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "14.37 14.6 11.62 18.93 8.29 14.43 4.37 20.6 5.63 21.4 8.38 17.07 11.71 21.57 15.63 15.4 14.37 14.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21,
    y: 15,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21,
    y: 18,
    width: 5,
    height: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 21,
    y: 21,
    width: 5,
    height: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentdashboard);
export default __webpack_public_path__ + "static/media/documentdashboard.fc4054dfe6f276b68c55971db3269753.svg";
export { ForwardRef as ReactComponent };